/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable default-case */
import React, {useEffect, useState} from 'react'

const RotaDriverRow = (props) => {
    const [mappedPropsRender, setMappedPropsRender] = useState(null)
    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }
    useEffect(() => {
        let mappedProps = []
        let localArray = []
        if (props.ele.Signed) {
            localArray.push(
                <div key={props.ele.name} className='cal_divs_single_first' id='blueOne'>
                    <h5 className='inner_calander_text'>
                        {props.id}. {props.ele.name}
                    </h5>
                </div>  
            )  
        } else {
            localArray.push(
                <div key={props.ele.name} className='cal_divs_single_first'>
                    <h5 className='inner_calander_text'>
                        {props.id+1}. {props.ele.name}
                    </h5>
                </div>  
            )  
        }
        if (parseInt(props.divAmount) === 14) {
            for (let i = 0; i < props.amount+1; i++) {
                localArray.push(
                    <div id="demo">
                        <div className="wrapper">
                            <div className="content" onClick={(e) => props.handleClick(e, props.checkForDate[i], props.ele.driver_id, props.ele.location)}>
                                <ul>
                                    <a href="#">
                                        <li>IN</li>
                                    </a>
                                    <a href="#">
                                        <li>CT</li>
                                    </a>
                                    <a href="#">
                                        <li>RT</li>
                                    </a>
                                    <a href="#">
                                        <li>Holiday</li>
                                    </a>
                                    <a href="#">
                                        <li>Manager</li>
                                    </a>
                                    <a href="#">
                                        <li>OFF</li>
                                    </a>
                                </ul>
                                <ul className='secondMenu'>
                                    <a href="#">
                                        <li>DBS2</li>
                                    </a>
                                    <a href="#">
                                        <li>DSN1</li>
                                    </a>
                                    <a href="#">
                                        <li>DEX2</li>
                                    </a>
                                    <a href="#">
                                        <li>DXP1</li>
                                    </a>
                                    <a href="#">
                                        <li>DCF1</li>
                                    </a>
                                </ul>
                            </div>
                            <div className="parent" id='inRed'>OFF</div>
                        </div>
                    </div>
                )  
            }
            let midTotal = 0
            let endTotal = 0
            const nameGiver = (theLocation, theRoute) => {
                if (theRoute === 'Classroom Training') {
                    return 'CT'
                } else if (theRoute === 'Ride Along') {
                    return 'RT'
                } else if (theRoute === 'secretLocation') {
                    return 'OFF'
                } else if (theRoute === 'Manager') {
                    return 'Manager'
                } else {
                    if (theLocation === props.selectedCity) {
                        return 'IN'
                    } else {
                        return theLocation
                    }
                }
            }
            props.checkForDate.forEach( dateItem => {
                if (props.lockedWeekList !== null) {
                    if (props.lockedWeekList.includes(new Date(dateItem).getWeek().toString())) {
                        localArray[props.checkForDate.indexOf(dateItem)+1] = (
                            <div id="demo">
                                <div className="wrapper">
                                    {/* <div className="content" onClick={(e) => props.handleClickPut(e, props.checkForDate[props.checkForDate.indexOf(dateEle.date)], props.ele.driver_id, props.ele.location)}>
                                    </div> */}
                                    <div className="parent" id='inRed'>
                                        OFF
                                    </div>
                                </div>
                            </div>
                        )
                    }
                }
            })

            // make the items appear but not clickable
            props.ele.datesList.forEach( (dateEle) => {
                if (props.lockedWeekList !== null) {
                    if (props.lockedWeekList.includes(new Date(dateEle.date).getWeek().toString())) {
                        if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                            // console.log(dateEle)
                            if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager' && dateEle.route !== 'Ride Along' && dateEle.route !== 'Classroom Training') {
                                if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                    midTotal++
                                }
                                if (props.checkForDate.indexOf(dateEle.date) > 7) {
                                    endTotal++
                                }
                            }
                            let colorChange
                            // eslint-disable-next-line default-case
                            switch (dateEle.location) {
                                case `${props.selectedCity}`:
                                    colorChange = 'inGreen' 
                                    break;
                                case 'Holiday':
                                    colorChange = 'inWhite'  
                                    break; 
                                case 'CT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'RT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'OFF':
                                    colorChange = 'inRed'
                                    break;  
                                default:
                                    colorChange = 'inYellow';    
                                    break; 
                            }
                            switch (dateEle.route) {
                                case 'Classroom Training':
                                    colorChange = 'inPurple'
                                    break;
                                case 'secretLocation':
                                    colorChange = 'inRed'
                                    break;  
                                case 'Ride Along':
                                    colorChange = 'inPurple'
                                    break;
                                case 'Manager':
                                    colorChange = 'inPurple'
                                    break;
                            }
                            localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                                <div id="demo">
                                    <div className="wrapper">
                                        <div className="parent" id={colorChange}>
                                            {nameGiver(dateEle.location, dateEle.route)}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    } else {
                    // make the items appear normal
                        if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                            // console.log(dateEle.date)
                            // console.log(dateEle)
                            if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager' && dateEle.route !== 'Ride Along' && dateEle.route !== 'Classroom Training') {
                                if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                    midTotal++
                                }
                                if (props.checkForDate.indexOf(dateEle.date) > 7) {
                                    endTotal++
                                }
                            }
                            let colorChange
                            // eslint-disable-next-line default-case
                            switch (dateEle.location) {
                                case `${props.selectedCity}`:
                                    colorChange = 'inGreen' 
                                    break;
                                case 'Holiday':
                                    colorChange = 'inWhite'  
                                    break; 
                                case 'CT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'RT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'OFF':
                                    colorChange = 'inRed'
                                    break;  
                                default:
                                    colorChange = 'inYellow';    
                                    break; 
                            }
                            switch (dateEle.route) {
                                case 'Classroom Training':
                                    colorChange = 'inPurple'
                                    break;
                                case 'secretLocation':
                                    colorChange = 'inRed'
                                    break;  
                                case 'Ride Along':
                                    colorChange = 'inPurple'
                                    break;
                                case 'Manager':
                                    colorChange = 'inPurple'
                                    break;
                            }
                            localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                                <div id="demo">
                                    <div className="wrapper">
                                        <div className="content" onClick={(e) => props.handleClickPut(e, props.checkForDate[props.checkForDate.indexOf(dateEle.date)], props.ele.driver_id, props.ele.location)}>
                                            <ul>
                                                <a href="#" ><li>IN</li></a>
                                                <a href="#" ><li>CT</li></a>
                                                <a href="#"><li>RT</li></a>
                                                <a href="#"><li>Holiday</li></a>
                                                <a href="#"><li>Manager</li></a>
                                                <a href="#"><li>OFF</li></a>
                                            </ul>
                                            <ul className='secondMenu'>
                                                <a href="#"><li>DBS2</li></a>
                                                <a href="#"><li>DSN1</li></a>
                                                <a href="#"><li>DEX2</li></a>
                                                <a href="#"><li>DXP1</li></a>
                                                <a href="#"><li>DCF1</li></a>
                                            </ul>
                                        </div>
                                        <div className="parent" id={colorChange}>
                                            {nameGiver(dateEle.location, dateEle.route)}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    }
                } else {
                    if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                        // console.log(dateEle)
                        if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager' && dateEle.route !== 'Ride Along' && dateEle.route !== 'Classroom Training') {
                            if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                midTotal++
                            }
                            if (props.checkForDate.indexOf(dateEle.date) > 7) {
                                endTotal++
                            }
                        }
                        let colorChange
                        // eslint-disable-next-line default-case
                        switch (dateEle.location) {
                            case `${props.selectedCity}`:
                                colorChange = 'inGreen' 
                                break;
                            case 'Holiday':
                                colorChange = 'inWhite'  
                                break; 
                            case 'CT':
                                colorChange = 'inPurple'
                                break;
                            case 'RT':
                                colorChange = 'inPurple'
                                break;
                            case 'OFF':
                                colorChange = 'inRed'
                                break;  
                            default:
                                colorChange = 'inYellow';    
                                break; 
                        }
                        switch (dateEle.route) {
                            case 'Classroom Training':
                                colorChange = 'inPurple'
                                break;
                            case 'secretLocation':
                                colorChange = 'inRed'
                                break;  
                            case 'Ride Along':
                                colorChange = 'inPurple'
                                break;
                            case 'Manager':
                                colorChange = 'inPurple'
                                break;
                        }
                        localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                            <div id="demo">
                                <div className="wrapper">
                                    <div className="content" onClick={(e) => props.handleClickPut(e, props.checkForDate[props.checkForDate.indexOf(dateEle.date)], props.ele.driver_id, props.ele.location)}>
                                        <ul>
                                            <a href="#" ><li>IN</li></a>
                                            <a href="#" ><li>CT</li></a>
                                            <a href="#"><li>RT</li></a>
                                            <a href="#"><li>Holiday</li></a>
                                            <a href="#"><li>Manager</li></a>
                                            <a href="#"><li>OFF</li></a>
                                        </ul>
                                        <ul className='secondMenu'>
                                            <a href="#"><li>DBS2</li></a>
                                            <a href="#"><li>DSN1</li></a>
                                            <a href="#"><li>DEX2</li></a>
                                            <a href="#"><li>DXP1</li></a>
                                            <a href="#"><li>DCF1</li></a>
                                        </ul>
                                    </div>
                                    <div className="parent" id={colorChange}>
                                        {nameGiver(dateEle.location, dateEle.route)}
                                    </div>
                                </div>
                            </div>
                        )
                    }
                }

            })
            if (midTotal === 7) {
                localArray[8] = (
                    <nav className="midTotal" id='redOne'>
                        {midTotal}
                    </nav>
                )
            } else if (midTotal === 6) {
                localArray[8] = (
                    <nav className="midTotal" id='yellowOne'>
                        {midTotal}
                    </nav>
                )
            } else {
                localArray[8] = (
                    <nav className="midTotal">
                        {midTotal}
                    </nav>
                )
            }
            if (endTotal === 7) {
                localArray[16] = (
                    <nav className="midTotal" id='redOne'>
                        {endTotal}
                    </nav>
                )
            } else if (endTotal === 6) {
                localArray[16] = (
                    <nav className="midTotal" id='yellowOne'>
                        {endTotal}
                    </nav>
                )
            } else {
                localArray[16] = (
                    <nav className="midTotal">
                        {endTotal}
                    </nav>
                )
            }
            mappedProps.push(localArray)
        } else if (parseInt(props.divAmount) === 21) {
            for (let i = 0; i < props.amount+2; i++) {
                localArray.push(
                    <div id="demo21">
                        <div className="wrapper">
                            <div className="content" onClick={(e) => props.handleClick(e, props.checkForDate[i], props.ele.driver_id, props.ele.location)}>
                                <ul>
                                    <a href="#">
                                        <li>IN</li>
                                    </a>
                                    <a href="#">
                                        <li>CT</li>
                                    </a>
                                    <a href="#">
                                        <li>RT</li>
                                    </a>
                                    <a href="#">
                                        <li>Holiday</li>
                                    </a>
                                    <a href="#">
                                        <li>Manager</li>
                                    </a>
                                    <a href="#">
                                        <li>OFF</li>
                                    </a>
                                </ul>
                                <ul className='secondMenu'>
                                    <a href="#">
                                        <li>DBS2</li>
                                    </a>
                                    <a href="#">
                                        <li>DSN1</li>
                                    </a>
                                    <a href="#">
                                        <li>DEX2</li>
                                    </a>
                                    <a href="#">
                                        <li>DXP1</li>
                                    </a>
                                    <a href="#">
                                        <li>DCF1</li>
                                    </a>
                                </ul>
                            </div>
                            <div className="parent" id='inRed'>OFF</div>
                        </div>
                    </div>
                )  
            }
            let midTotal = 0
            let endTotal = 0
            let finalEnd = 0
            const nameGiver = (theLocation, theRoute) => {
                if (theRoute === 'Classroom Training') {
                    return 'CT'
                } else if (theRoute === 'Ride Along') {
                    return 'RT'
                } else if (theRoute === 'secretLocation') {
                    return 'OFF'
                } else if (theRoute === 'Manager') {
                    return 'Manager'
                } 
                else {
                    if (theLocation === props.selectedCity) {
                        return 'IN'
                    } else {
                        return theLocation
                    }
                }
            }

            // handle the locked version
            props.checkForDate.forEach( dateItem => {
                if (props.lockedWeekList !== null) {
                    if (props.lockedWeekList.includes(new Date(dateItem).getWeek().toString())) {
                        localArray[props.checkForDate.indexOf(dateItem)+1] = (
                            <div id="demo21">
                                <div className="wrapper">
                                    <div className="parent" id='inRed'>
                                        OFF
                                    </div>
                                </div>
                            </div>
                        )
                    }
                }
            })
            props.ele.datesList.forEach( (dateEle) => {
                if (props.lockedWeekList !== null) {
                    if (props.lockedWeekList.includes(new Date(dateEle.date).getWeek().toString())) {
                        if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                            // console.log(dateEle.date)
                            if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager' && dateEle.route !== 'Ride Along' && dateEle.route !== 'Classroom Training') {
                                if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                    midTotal++
                                }
                                if (props.checkForDate.indexOf(dateEle.date) > 7 && props.checkForDate.indexOf(dateEle.date) < 14) {
                                    endTotal++
                                }
                                if (props.checkForDate.indexOf(dateEle.date) > 14) {
                                    finalEnd++
                                }
                            }
                            let colorChange
                            // eslint-disable-next-line default-case
                            switch (dateEle.location) {
                                case `${props.selectedCity}`:
                                    colorChange = 'inGreen' 
                                    break;
                                case 'Holiday':
                                    colorChange = 'inWhite'  
                                    break; 
                                case 'CT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'RT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'OFF':
                                    colorChange = 'inRed'
                                    break;  
                                default:
                                    colorChange = 'inYellow';    
                                    break; 
                            }
                            switch (dateEle.route) {
                                case 'Classroom Training':
                                    colorChange = 'inPurple'
                                    break;
                                case 'secretLocation':
                                    colorChange = 'inRed'
                                    break;  
                                case 'Ride Along':
                                    colorChange = 'inPurple'
                                    break;
                                case 'Manager':
                                    colorChange = 'inPurple'
                                    break;
                            }
                            localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                                <div id="demo21">
                                    <div className="wrapper">
                                        <div className="parent" id={colorChange}>
                                            {nameGiver(dateEle.location, dateEle.route)}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    } else {
                        if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                            // console.log(dateEle.date)
                            if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager'  && dateEle.route !== 'Ride Along' && dateEle.route !== 'Classroom Training') {
                                if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                    midTotal++
                                }
                                if (props.checkForDate.indexOf(dateEle.date) > 7 && props.checkForDate.indexOf(dateEle.date) < 14) {
                                    endTotal++
                                }
                                if (props.checkForDate.indexOf(dateEle.date) > 14) {
                                    finalEnd++
                                }
                            }
                            let colorChange
                            // eslint-disable-next-line default-case
                            switch (dateEle.location) {
                                case `${props.selectedCity}`:
                                    colorChange = 'inGreen' 
                                    break;
                                case 'Holiday':
                                    colorChange = 'inWhite'  
                                    break; 
                                case 'CT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'RT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'OFF':
                                    colorChange = 'inRed'
                                    break;  
                                default:
                                    colorChange = 'inYellow';    
                                    break; 
                            }
                            switch (dateEle.route) {
                                case 'Classroom Training':
                                    colorChange = 'inPurple'
                                    break;
                                case 'secretLocation':
                                    colorChange = 'inRed'
                                    break;  
                                case 'Ride Along':
                                    colorChange = 'inPurple'
                                    break;
                                case 'Manager':
                                    colorChange = 'inPurple'
                                    break;
                            }
                            localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                                <div id="demo21">
                                    <div className="wrapper">
                                        <div className="content" onClick={(e) => props.handleClickPut(e, props.checkForDate[props.checkForDate.indexOf(dateEle.date)], props.ele.driver_id, props.ele.location)}>
                                            <ul>
                                                <a href="#" ><li>IN</li></a>
                                                <a href="#" ><li>CT</li></a>
                                                <a href="#"><li>RT</li></a>
                                                <a href="#"><li>Holiday</li></a>
                                                <a href="#"><li>Manager</li></a>
                                                <a href="#"><li>OFF</li></a>
                                            </ul>
                                            <ul className='secondMenu'>
                                                <a href="#"><li>DBS2</li></a>
                                                <a href="#"><li>DSN1</li></a>
                                                <a href="#"><li>DEX2</li></a>
                                                <a href="#"><li>DXP1</li></a>
                                                <a href="#"><li>DCF1</li></a>
                                            </ul>
                                        </div>
                                        <div className="parent" id={colorChange}>
                                            {nameGiver(dateEle.location, dateEle.route)}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    }
                } else {
                    if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                        // console.log(dateEle.date)
                        if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager'  && dateEle.route !== 'Ride Along' && dateEle.route !== 'Classroom Training') {
                            if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                midTotal++
                            }
                            if (props.checkForDate.indexOf(dateEle.date) > 7 && props.checkForDate.indexOf(dateEle.date) < 14) {
                                endTotal++
                            }
                            if (props.checkForDate.indexOf(dateEle.date) > 14) {
                                finalEnd++
                            }
                        }
                        let colorChange
                        // eslint-disable-next-line default-case
                        switch (dateEle.location) {
                            case `${props.selectedCity}`:
                                colorChange = 'inGreen' 
                                break;
                            case 'Holiday':
                                colorChange = 'inWhite'  
                                break; 
                            case 'CT':
                                colorChange = 'inPurple'
                                break;
                            case 'RT':
                                colorChange = 'inPurple'
                                break;
                            case 'OFF':
                                colorChange = 'inRed'
                                break;  
                            default:
                                colorChange = 'inYellow';    
                                break; 
                        }
                        switch (dateEle.route) {
                            case 'Classroom Training':
                                colorChange = 'inPurple'
                                break;
                            case 'secretLocation':
                                colorChange = 'inRed'
                                break;  
                            case 'Ride Along':
                                colorChange = 'inPurple'
                                break;
                            case 'Manager':
                                colorChange = 'inPurple'
                                break;
                        }
                        localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                            <div id="demo21">
                                <div className="wrapper">
                                    <div className="content" onClick={(e) => props.handleClickPut(e, props.checkForDate[props.checkForDate.indexOf(dateEle.date)], props.ele.driver_id, props.ele.location)}>
                                        <ul>
                                            <a href="#" ><li>IN</li></a>
                                            <a href="#" ><li>CT</li></a>
                                            <a href="#"><li>RT</li></a>
                                            <a href="#"><li>Holiday</li></a>
                                            <a href="#"><li>Manager</li></a>
                                            <a href="#"><li>OFF</li></a>
                                        </ul>
                                        <ul className='secondMenu'>
                                            <a href="#"><li>DBS2</li></a>
                                            <a href="#"><li>DSN1</li></a>
                                            <a href="#"><li>DEX2</li></a>
                                            <a href="#"><li>DXP1</li></a>
                                            <a href="#"><li>DCF1</li></a>
                                        </ul>
                                    </div>
                                    <div className="parent" id={colorChange}>
                                        {nameGiver(dateEle.location, dateEle.route)}
                                    </div>
                                </div>
                            </div>
                        )
                    }
                }
            })
            if (midTotal === 7) {
                localArray[8] = (
                    <nav className="midTotal21" id='redOne'>
                        {midTotal}
                    </nav>
                )
            } else if (midTotal === 6) {
                localArray[8] = (
                    <nav className="midTotal21" id='yellowOne'>
                        {midTotal}
                    </nav>
                )
            } else {
                localArray[8] = (
                    <nav className="midTotal21">
                        {midTotal}
                    </nav>
                )
            }
            if (endTotal === 7) {
                localArray[16] = (
                    <nav className="midTotal21" id='redOne'>
                        {endTotal}
                    </nav>
                )
            } else if (endTotal === 6) {
                localArray[16] = (
                    <nav className="midTotal21" id='yellowOne'>
                        {endTotal}
                    </nav>
                )
            } else {
                localArray[16] = (
                    <nav className="midTotal21">
                        {endTotal}
                    </nav>
                )
            }
            if (finalEnd === 7) {
                localArray[24] = (
                    <nav className="midTotal21" id='redOne'>
                        {finalEnd}
                    </nav>
                )
            } else if (endTotal === 6) {
                localArray[24] = (
                    <nav className="midTotal21" id='yellowOne'>
                        {finalEnd}
                    </nav>
                )
            } else {
                localArray[24] = (
                    <nav className="midTotal21">
                        {finalEnd}
                    </nav>
                )
            }
            mappedProps.push(localArray)
        } else {
            const nameGiver = (theLocation, theRoute) => {
                if (theRoute === 'Classroom Training') {
                    return 'CT'
                } else if (theRoute === 'Ride Along') {
                    return 'RT'
                } else if (theRoute === 'secretLocation') {
                    return 'OFF'
                } else if (theRoute === 'Manager') {
                    return 'Manager'
                } 
                else {
                    if (theLocation === props.selectedCity) {
                        return 'IN'
                    } else {
                        return theLocation
                    }
                }
            }
            // dropdown menu options
            let midTotal = 0
            const optionsThree = props.getSundaysSeven()
            let localArray= []
            localArray.push(
                <div className='cal_divs_single_first'>
                    <h5 className='inner_calander_text'>
                        {props.ele.name}
                    </h5>
                </div>  
            )  
            for (let i = 0; i < 8; i++) {
                localArray.push(
                    <div id="demoSeven">
                        <div class="wrapper">
                            <div class="content" onClick={(e) => props.handleClick(e, props.checkForDate[i], props.ele.driver_id, props.ele.location)}>
                                <ul>
                                    <a href="#">
                                        <li>IN</li>
                                    </a>
                                    <a href="#">
                                        <li>CT</li>
                                    </a>
                                    <a href="#">
                                        <li>RT</li>
                                    </a>
                                    <a href="#">
                                        <li>Holiday</li>
                                    </a>
                                    <a href="#">
                                        <li>Manager</li>
                                    </a>
                                    <a href="#">
                                        <li>OFF</li>
                                    </a>
                                </ul>
                                <ul className='secondMenu'>
                                    <a href="#">
                                        <li>DBS2</li>
                                    </a>
                                    <a href="#">
                                        <li>DSN1</li>
                                    </a>
                                    <a href="#">
                                        <li>DEX2</li>
                                    </a>
                                    <a href="#">
                                        <li>DXP1</li>
                                    </a>
                                    <a href="#">
                                        <li>DCF1</li>
                                    </a>
                                </ul>
                            </div>
                            <div class="parent" id='inRed'>OFF</div>
                        </div>
                    </div>
                )  
            }
            props.checkForDate.forEach( dateItem => {
                if (props.lockedWeekList !== null) {
                    if (props.lockedWeekList.includes(new Date(dateItem).getWeek().toString())) {
                        localArray[props.checkForDate.indexOf(dateItem)+1] = (
                            <div id="demoSeven">
                                <div class="wrapper">
                                    <div class="parent" id='inRed'>OFF</div>
                                </div>
                            </div>
                        )
                    }
                }
            })
            // eslint-disable-next-line no-loop-func
            let localSevenDayCheck = []
            props.ele.datesList.forEach( (dateEle) => {
                if (props.lockedWeekList !== null) {
                    if (props.lockedWeekList.includes(new Date(dateEle.date).getWeek().toString())) {
                        if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                            if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager'  && dateEle.route !== 'Ride Along' && dateEle.route !== 'Classroom Training') {
                                if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                    midTotal++
                                }
                            }
                            let colorChange
                            // eslint-disable-next-line default-case
                            switch (dateEle.location) {
                                case `${props.selectedCity}`:
                                    colorChange = 'inGreen' 
                                    break;
                                case 'Holiday':
                                    colorChange = 'inWhite'  
                                    break; 
                                case 'CT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'RT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'OFF':
                                    colorChange = 'inRed'
                                    break;
                                default:
                                    colorChange = 'inYellow';    
                                    break; 
                            }
                            switch (dateEle.route) {
                                case 'Classroom Training':
                                    colorChange = 'inPurple'
                                    break;
                                case 'Ride Along':
                                    colorChange = 'inPurple'
                                    break;
                                case 'Manager':
                                    colorChange = 'inPurple'
                                    break;
                                default:
                                    break;    
                            }
                            localSevenDayCheck.push(props.checkForDate.indexOf(dateEle.date)+1)
                            localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                                <div id="demoSeven">
                                    <div class="wrapper">
                                        <div class="parent" id={colorChange}>{nameGiver(dateEle.location, dateEle.route)}</div>
                                    </div>
                                </div>
                            )
                        }
                    } else {
                        if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                            if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager') {
                                if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                    midTotal++
                                }
                            }
                            let colorChange
                            // eslint-disable-next-line default-case
                            switch (dateEle.location) {
                                case `${props.selectedCity}`:
                                    colorChange = 'inGreen' 
                                    break;
                                case 'Holiday':
                                    colorChange = 'inWhite'  
                                    break; 
                                case 'CT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'RT':
                                    colorChange = 'inPurple'
                                    break;
                                case 'OFF':
                                    colorChange = 'inRed'
                                    break;
                                default:
                                    colorChange = 'inYellow';    
                                    break; 
                            }
                            switch (dateEle.route) {
                                case 'Classroom Training':
                                    colorChange = 'inPurple'
                                    break;
                                case 'Ride Along':
                                    colorChange = 'inPurple'
                                    break;
                                case 'Manager':
                                    colorChange = 'inPurple'
                                    break;
                                default:
                                    break;    
                            }
                            localSevenDayCheck.push(props.checkForDate.indexOf(dateEle.date)+1)
                            localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                                <div id="demoSeven">
                                    <div class="wrapper">
                                        <div class="content" onClick={(e) => props.handleClickPut(e, props.checkForDate[props.checkForDate.indexOf(dateEle.date)], props.ele.driver_id, props.ele.location)}>
                                            <ul>
                                                <a href="#" ><li>IN</li></a>
                                                <a href="#" ><li>CT</li></a>
                                                <a href="#"><li>RT</li></a>
                                                <a href="#"><li>Holiday</li></a>
                                                <a href="#"><li>Manager</li></a>
                                                <a href="#"><li>OFF</li></a>
                                            </ul>
                                            <ul className='secondMenu'>
                                                <a href="#"><li>DBS2</li></a>
                                                <a href="#"><li>DSN1</li></a>
                                                <a href="#"><li>DEX2</li></a>
                                                <a href="#"><li>DXP1</li></a>
                                                <a href="#"><li>DCF1</li></a>
                                            </ul>
                                        </div>
                                        <div class="parent" id={colorChange}>{nameGiver(dateEle.location, dateEle.route)}</div>
                                    </div>
                                </div>
                            )
                        }
                    }
                } else {
                    if (dateEle.location !== 'OFF' && props.checkForDate.includes(dateEle.date)) {
                        if (dateEle.location !== 'Holiday' && dateEle.route !== 'Manager') {
                            if (props.checkForDate.indexOf(dateEle.date) < 7) {
                                midTotal++
                            }
                        }
                        let colorChange
                        // eslint-disable-next-line default-case
                        switch (dateEle.location) {
                            case `${props.selectedCity}`:
                                colorChange = 'inGreen' 
                                break;
                            case 'Holiday':
                                colorChange = 'inWhite'  
                                break; 
                            case 'CT':
                                colorChange = 'inPurple'
                                break;
                            case 'RT':
                                colorChange = 'inPurple'
                                break;
                            case 'OFF':
                                colorChange = 'inRed'
                                break;
                            default:
                                colorChange = 'inYellow';    
                                break; 
                        }
                        switch (dateEle.route) {
                            case 'Classroom Training':
                                colorChange = 'inPurple'
                                break;
                            case 'Ride Along':
                                colorChange = 'inPurple'
                                break;
                            case 'Manager':
                                colorChange = 'inPurple'
                                break;
                            default:
                                break;    
                        }
                        localSevenDayCheck.push(props.checkForDate.indexOf(dateEle.date)+1)
                        localArray[props.checkForDate.indexOf(dateEle.date)+1] = (
                            <div id="demoSeven">
                                <div class="wrapper">
                                    <div class="content" onClick={(e) => props.handleClickPut(e, props.checkForDate[props.checkForDate.indexOf(dateEle.date)], props.ele.driver_id, props.ele.location)}>
                                        <ul>
                                            <a href="#" ><li>IN</li></a>
                                            <a href="#" ><li>CT</li></a>
                                            <a href="#"><li>RT</li></a>
                                            <a href="#"><li>Holiday</li></a>
                                            <a href="#"><li>Manager</li></a>
                                            <a href="#"><li>OFF</li></a>
                                        </ul>
                                        <ul className='secondMenu'>
                                            <a href="#"><li>DBS2</li></a>
                                            <a href="#"><li>DSN1</li></a>
                                            <a href="#"><li>DEX2</li></a>
                                            <a href="#"><li>DXP1</li></a>
                                            <a href="#"><li>DCF1</li></a>
                                        </ul>
                                    </div>
                                    <div class="parent" id={colorChange}>{nameGiver(dateEle.location, dateEle.route)}</div>
                                </div>
                            </div>
                        )
                    }
                }
            })
            if (midTotal === 7) {
                localArray[8] = (
                    <nav className="midTotalSeven" id='redOne'>
                        {midTotal}
                    </nav>
                )
            } else if (midTotal === 6) {
                localArray[8] = (
                    <nav className="midTotalSeven" id='yellowOne'>
                        {midTotal}
                    </nav>
                )
            } else {
                localArray[8] = (
                    <nav className="midTotalSeven">
                        {midTotal}
                    </nav>
                )
            }
            mappedProps.push(localArray)
        }
        setMappedPropsRender(mappedProps)
    }, [props])
    return( 
        <>
            {mappedPropsRender}
        </>
    )
}
export default RotaDriverRow